"use strict";

angular.module("customer")
.component("notificationList", {
    templateUrl: require("./notification-list.html"),
    controller: NotificationListController,
    controllerAs: "notificationListCtrl",
    bindings: {
        filterUnread: "<",
        unreadRemaining: "=?"
    }
});

function NotificationListController($rootScope, $scope, $timeout, NotificationService, REFRESH_NOTIFICATION_LISTING) {
    var _this = this;
    $scope.scrollFetching = false;
    $scope.scrollDisabled = false;
    $scope.pagination = {};

    var unregisterNotification = $scope.$on(REFRESH_NOTIFICATION_LISTING, function(event, filterUnread) {
        $scope.pagination = {};
        $scope.notifications = undefined;
        _this.filterUnread = filterUnread;
        _this.getMoreNotifications();
    });

    $scope.$on("$destroy", function() {
        unregisterNotification();
    });

    this.markAsRead = function(notification) {
        NotificationService.markAsRead(notification).then(function onSuccess(data) {
            notification.unread = data.unread;
            $rootScope.UpdateCurrentNumbers().then(function() {
                $timeout(refreshUnreadCount, 500);
            });
        });
    };

    this.fetchNotifications = function() {
        $scope.scrollFetching = true;
        NotificationService.query(_this.filterUnread, $scope.pagination.current_page).then(function onSuccess(data) {
            if (typeof $scope.notifications === "undefined") {
                $scope.notifications = [];
            }
            $scope.notifications = $scope.notifications.concat(data.results);
            $scope.pagination = data.pagination;
            $scope.scrollFetching = false;
            $timeout(refreshUnreadCount, 500);
        }, function onError() {
            $scope.scrollDisabled = true;
        });
    };

    this.getMoreNotifications = function() {
        if (typeof $scope.pagination.num_pages === "undefined") {
            this.fetchNotifications();
        }
        else if ($scope.pagination.current_page === $scope.pagination.num_pages || $scope.pagination.num_pages === 1) {
            $scope.scrollDisabled = true;
        }
        else if ($scope.pagination.num_pages > 1) {
            $scope.pagination.current_page++;
            this.fetchNotifications();
        }
        else {
            $scope.scrollDisabled = true;
        }
    };

    function refreshUnreadCount() {
        var currentNumbers = $rootScope.CurrentNumbers;
        var hasNotification = currentNumbers && currentNumbers.notification_count > 0;
        var unreadCount = hasNotification ? currentNumbers.notification_count : 0;
        var unreadTotalDisplayed = 0;

        angular.forEach($scope.notifications, function(value, key) {
            if (value.unread) {
                unreadTotalDisplayed++;
            }
        });

        _this.unreadRemaining = unreadCount > unreadTotalDisplayed ? unreadCount - unreadTotalDisplayed : 0;
    }
}



//////////////////
// WEBPACK FOOTER
// ./core/notification/notification-list/notification-list.component.js
// module id = 877
// module chunks = 0